<template>
    <base-circular-new pagetitle="Templates" :step="1" title="Escolha um template" subtitle="Escolha o template que irá utilizar para criar sua nova circular de produtos.">
        <!-- <div class="col s12 m6">
            <div class="card horizontal">
                <div class="card-image">
                    <img :src="require('../../assets/img/template_3.jpeg')">
                </div>
                <div class="card-stacked">
                    <div class="card-content">
                        <p>Template com 4 itens.</p>
                    </div>
                    <div class="card-action">
                        <router-link to="/escolher-produtos/2" style="color: #478FF1">Escolher</router-link>
                    </div>
                </div>
            </div>
        </div> -->
        <div class="col s12 m6">
            <div class="card horizontal">
                <div class="card-image">
                    <img :src="require('../../assets/layouts/layout_com2.jpg')">
                </div>
                <div class="card-stacked">
                    <div class="card-content">
                        <p>Template com 2 itens.</p>
                    </div>
                    <div class="card-action">
                        <router-link to="/escolher-produtos/1" style="color: #478FF1">Escolher</router-link>
                    </div>
                </div>
            </div>
        </div>
        <div class="col s12 m6">
            <div class="card horizontal">
                <div class="card-image">
                    <img :src="require('../../assets/layouts/layout_com3.jpg')">
                </div>
                <div class="card-stacked">
                    <div class="card-content">
                        <p>Template com 3 itens.</p>
                    </div>
                    <div class="card-action">
                        <router-link to="/escolher-produtos/2" style="color: #478FF1">Escolher</router-link>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div class="col s12 m6">
            <div class="card horizontal">
                <div class="card-image">
                    <img :src="require('../../assets/layouts/layout_com4.jpg')">
                </div>
                <div class="card-stacked">
                    <div class="card-content">
                        <p>Template com 4 itens.</p>
                    </div>
                    <div class="card-action">
                        <router-link to="/escolher-produtos/3" style="color: #478FF1">Escolher</router-link>
                    </div>
                </div>
            </div>
        </div> -->
        <div class="col s12 m6">
            <div class="card horizontal">
                <div class="card-image">
                    <img :src="require('../../assets/layouts/layout_com5.jpg')">
                </div>
                <div class="card-stacked">
                    <div class="card-content">
                        <p>Template com 5 itens.</p>
                    </div>
                    <div class="card-action">
                        <router-link to="/escolher-produtos/4" style="color: #478FF1">Escolher</router-link>
                    </div>
                </div>
            </div>
        </div>
        <div class="col s12 m6">
            <div class="card horizontal">
                <div class="card-image">
                    <img :src="require('../../assets/layouts/layout_com6.jpg')">
                </div>
                <div class="card-stacked">
                    <div class="card-content">
                        <p>Template com 6 itens.</p>
                    </div>
                    <div class="card-action">
                        <router-link to="/escolher-produtos/5" style="color: #478FF1">Escolher</router-link>
                    </div>
                </div>
            </div>
        </div>
        <div class="col s12 m6">
            <div class="card horizontal">
                <div class="card-image">
                    <img :src="require('../../assets/layouts/layout_com7.jpg')">
                </div>
                <div class="card-stacked">
                    <div class="card-content">
                        <p>Template com 7 itens.</p>
                    </div>
                    <div class="card-action">
                        <router-link to="/escolher-produtos/6" style="color: #478FF1">Escolher</router-link>
                    </div>
                </div>
            </div>
        </div>
        <div class="col s12 m6">
            <div class="card horizontal">
                <div class="card-image">
                    <img :src="require('../../assets/layouts/layout_com8.jpg')">
                </div>
                <div class="card-stacked">
                    <div class="card-content">
                        <p>Template com 8 itens.</p>
                    </div>
                    <div class="card-action">
                        <router-link to="/escolher-produtos/7" style="color: #478FF1">Escolher</router-link>
                    </div>
                </div>
            </div>
        </div>
        <div class="col s12 m6">
            <div class="card horizontal">
                <div class="card-image">
                    <img :src="require('../../assets/layouts/layout_com9.jpg')">
                </div>
                <div class="card-stacked">
                    <div class="card-content">
                        <p>Template com 9 itens.</p>
                    </div>
                    <div class="card-action">
                        <router-link to="/escolher-produtos/8" style="color: #478FF1">Escolher</router-link>
                    </div>
                </div>
            </div>
        </div>
    </base-circular-new>
</template>

<script>
import BaseCircularNew from "../shared/base_circular_new/BaseCircularNew.vue";
export default {
    name: 'choice_template',
    components: {
        "base-circular-new": BaseCircularNew
    },
    mounted() {
        $(document).ready(function() {
            $('.fixed-action-btn').floatingActionButton();

            $('.tooltipped').tooltip();
        });
    }
}
</script>

<style lang="scss" scoped>
    .height100 {
            height: 100vh;
        }

        #left-bar {
            border-right: 2px solid #DEE4EA;
        }

        #steps-container {
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            margin-top: 10%;
        }

        .step {
          width: 2.5em;
          height: 2.5em;
          text-align: center;
          line-height: 2.5em;
          position: relative;
          margin-bottom: 10px;
          float: left;
          margin-left: 5px;
        }

        .step span {
          position: relative;
          font-family: 'Helvetica Neue', Arial, sans-serif;
          font-weight: 200;
          font-size: 1.5em;
          color: #8F9297;
          z-index: 1000;
          white-space: nowrap;
        }

        .step.active span {
          color: #478FF1;
        }

        .step::before {
          position: absolute;
          left: 5%;
          top: 5%;
          height: 90%;
          width: 90%;
          background: white;
          content: '';
          z-index: 600;
          border-radius: 50%;
        }

        .step::after {
          position: absolute;
          left: 0;
          top: 0;
          height: 100%;
          width: 100%;
          background: #fff;
          content: '';
          z-index: 500;
          border-radius: 50%;
        }

        .step.active::after {
          background: #478FF1;
        }

        .center-el {
            position: relative;
            left: 50%;
            transform: translateX(-50%);
        }
</style>





// WEBPACK FOOTER //
// src/components/choice_template/ChoiceTemplate.vue